export enum TagTypeValue {
  DOMAIN = "domain",
  HOST = "host",
}
